import rows from '../../json/soldierStats.json';
import _ from 'lodash';
/**
 * @author James Adams
 */
function SoldiersState(id){
  this.createCachedPageState(id,{
    sort:[],
    filter:{},
    columnView:{},
    columnOrder:[],
    selection:[],
    errorMessage:"",
    custom: _.cloneDeep(rows),
    confirmDisplay:"closed",
    confirmMessage:"",
    version2:"version2"
  },[
    "custom",
    "version2"
  ]);
}

export default SoldiersState;
